import React from 'react';
import Decimal from 'decimal.js';

import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  propTypes,
  LINE_ITEM_CUSTOMER_COMMISSION,
  LINE_ITEM_PROVIDER_COMMISSION,
} from '../../util/types';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

/**
 * Calculates the total price in sub units for multiple line items.
 */
const lineItemsTotal = (lineItems, marketplaceCurrency) => {
  const amount = lineItems.reduce((total, item) => {
    return total.plus(item.lineTotal.amount);
  }, new Decimal(0));
  const currency = lineItems[0] ? lineItems[0].lineTotal.currency : marketplaceCurrency;
  return new Money(amount, currency);
};

/**
 * Checks if line item represents commission
 */
const isCommission = lineItem => {
  return (
    lineItem.code === LINE_ITEM_PROVIDER_COMMISSION ||
    lineItem.code === LINE_ITEM_CUSTOMER_COMMISSION
  );
};

/**
 * Returns non-commission, reversal line items
 */
const nonCommissionReversalLineItems = lineItems => {
  return lineItems.filter(item => !isCommission(item) && item.reversal);
};

const LineItemRefundMaybe = props => {
  const {
    lineItems,
    intl,
    marketplaceCurrency,
    isProvider,
    isCustomer,
    currentCurrency,
    customerTotalConverted,
    providerRefundConverted,
  } = props;

  // all non-commission, reversal line items
  const refundLineItems = nonCommissionReversalLineItems(lineItems);

  const refund = lineItemsTotal(refundLineItems, marketplaceCurrency);

  const formattedRefund = refundLineItems.length > 0 ? formatMoney(intl, refund) : null;

  if (!formattedRefund) return null;

  const customerRefund =
    !isNaN(customerTotalConverted) &&
    formatMoney(
      intl,
      new Money(Math.ceil(customerTotalConverted / 100) * 100 * -1, currentCurrency)
    );

  const providerRefund =
    !isNaN(providerRefundConverted) &&
    formatMoney(
      intl,
      new Money(Math.ceil(providerRefundConverted / 100) * 100 * -1, currentCurrency)
    );

  return (
    formattedRefund && (
      <div className={css.lineItem}>
        <span className={css.itemLabel}>
          <FormattedMessage id="OrderBreakdown.refund" />
        </span>
        {isCustomer && <span className={css.itemValue}>{customerRefund || formattedRefund}</span>}
        {isProvider && <span className={css.itemValue}>{providerRefund || formattedRefund}</span>}
      </div>
    )
  );
};

LineItemRefundMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemRefundMaybe;
